import { Service } from '@tino-frontend/adapters'
import { QuizAnswerResponse, QuizPayload, QuizResponse } from '@types'

export class QuizService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  create(): Promise<QuizResponse> {
    return this.http.post(`/onboarding/quiz`)
  }

  submit(id: string, payload: QuizPayload): Promise<QuizAnswerResponse> {
    return this.http.post(`/onboarding/quiz/${id}/answer`, payload)
  }
}
